export const DELAY_CODE_LABELS = {
  delayCode: {
    singular: "Delay Code",
    plural: "Delay Codes",
  },
  reason: {
    singular: "Reason",
    plural: "Reasons",
  },
} as const;

export type DelayCodeLabelVariant = keyof typeof DELAY_CODE_LABELS;
export type DelayCodeLabels = (typeof DELAY_CODE_LABELS)[DelayCodeLabelVariant];
